module.exports = __webpack_public_path__ + "static/media/send_active.28dce24e.svg";